
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    if (this.id) {
      this.getData();
    }
  }
  private data: any = [];
  private getData() {
    this.data = {};
  }
}
